import { DOCUMENT } from '@angular/common';
import { createComponent, EnvironmentInjector, inject, Injectable } from '@angular/core';

import { IconsContainerComponent } from '@core/user-interface-legacy';
@Injectable({ providedIn: 'root' })
export class TellentClientIconsContainer {
  public injector = inject(EnvironmentInjector);
  public doc = inject(DOCUMENT);

  constructor() {
    const component = createComponent(IconsContainerComponent, {
      environmentInjector: this.injector,
    });

    const host: HTMLElement = component.location.nativeElement;
    host.style.display = 'none';
    document.body.appendChild(host);

    component.changeDetectorRef.detectChanges();
  }
}
